import { ReactElement } from "react";
import { GridProps, Typography, TypographyProps } from "@mui/material";
import { Controller } from "react-hook-form";
import FormGridRow from "../../common/components/functional/formGridRow/FormGridRow";

type Props = {
  label?: string;
  name: string;
  control?: any;
  component?: ReactElement;
  GridLabelProps?: GridProps;
  GridFieldProps?: GridProps;
  TypographyProps?: TypographyProps;
};

const FeedbackFormRow = ({
  label,
  name,
  control,
  component,
  GridLabelProps = {},
  GridFieldProps = {},
  TypographyProps = {},
}: Props) => (
  <FormGridRow
    label={label}
    labelSize={4}
    fieldSize={8}
    GridLabelProps={GridLabelProps}
    GridFieldProps={GridFieldProps}
  >
    {component || (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Typography {...TypographyProps}>{field.value}</Typography>
        )}
      />
    )}
  </FormGridRow>
);

export default FeedbackFormRow;
